import React from "react";
import "./Gallery.css";

import cake1 from "../images/cake1.jpg";
import cake2 from "../images/cake2.jpg";
import cake3 from "../images/cake3.jpg";
import cake4 from "../images/cake5.jpg";
import cake5 from "../images/cake6.jpg";
import cake6 from "../images/cake7.jpg";
import cake7 from "../images/cake8.jpg";

const Gallery = () => {
  return (
    <section className="gallery">
      <div className="gallery-header">
        <h1>Our Creations</h1>
        <p>
          Thoughtfully designed cakes crafted for moments that matter.
        </p>
      </div>

      <div className="gallery-grid">
        <div className="gallery-item">
          <img src={cake1} alt="Chocolate Cake" />
        </div>
        <div className="gallery-item tall">
          <img src={cake2} alt="Red Velvet Cake" />
        </div>
        <div className="gallery-item">
          <img src={cake3} alt="Custom Cake" />
        </div>
  
       
      </div>
    </section>
  );
};

export default Gallery;
